import createSvgIcon from "./utils/create_icon"

const ProfileFill = createSvgIcon(<path clipRule="evenodd" d="M18.36 19.716A9.96 9.96 0 0 1 12 22a9.965 9.965 0 0 1-6.8-2.668A9.973 9.973 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.973 9.973 0 0 1-3.64 7.716zm-.396-2.383a8 8 0 1 0-11.927 0 7.019 7.019 0 0 1 3.775-2.984 4 4 0 1 1 4.377 0 7.019 7.019 0 0 1 3.775 2.984z" fill="currentColor" fillRule="evenodd" />, "ProfileFill")
export default ProfileFill
